import { memo } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

function ForArtists({ colors }) {
  return (
        <Box id="home-artists" sx={{ py: { xs: 6, md: 10 } }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
              variant="overline"
              sx={{ color: colors.primaryLight, fontWeight: 700, letterSpacing: '0.08em' }}
            >
              Pensé pour les artistes
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                mt: 1,
                mb: 2,
                color: colors.textPrimary,
                fontSize: { xs: '2rem', md: '2.5rem' },
              }}
            >
              Vos droits, votre musique, votre liberté
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: colors.textSecondary, maxWidth: 720, mx: 'auto', lineHeight: 1.7 }}
            >
              Déposer une œuvre à la SACEM a longtemps été un parcours administratif décourageant,
              réservé à ceux qui avaient un éditeur ou un avocat. Publy change la donne :
              vous gérez vos déclarations vous-même, en quelques minutes, sans rien céder de vos droits.
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                icon: <LockOpenIcon sx={{ fontSize: 32 }} />,
                title: 'Restez 100% indépendant',
                description: "Pas besoin de signer avec un éditeur pour déclarer vos œuvres. Vous gardez la totalité de vos droits d'auteur et le contrôle de votre catalogue.",
                color: colors.primaryLight,
              },
              {
                icon: <MusicNoteIcon sx={{ fontSize: 32 }} />,
                title: 'Concentrez-vous sur la musique',
                description: "L'assistant collecte les informations pour vous et génère automatiquement vos feuillets SACEM et contrats. Vous créez, on s'occupe de la paperasse.",
                color: colors.secondary,
              },
              {
                icon: <VerifiedUserIcon sx={{ fontSize: 32 }} />,
                title: 'Sans stress, sans erreur',
                description: "Fini les formulaires complexes et la peur de mal remplir. On vous guide pas à pas et on vérifie la cohérence de chaque déclaration avant l'envoi.",
                color: colors.info,
              },
              {
                icon: <FavoriteBorderIcon sx={{ fontSize: 32 }} />,
                title: 'Accessible à tous',
                description: "Que vous déposiez votre premier titre ou votre centième, l'expérience reste simple et abordable. Pas de jargon, pas d'engagement caché.",
                color: colors.success,
              },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    height: '100%',
                    p: { xs: 3, md: 3.5 },
                    bgcolor: colors.bgPaper,
                    border: `1px solid ${colors.border}`,
                    borderRadius: 3,
                    display: 'flex',
                    gap: 2,
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: item.color,
                      transform: 'translateY(-4px)',
                      boxShadow: `0 12px 24px ${item.color}20`,
                    },
                  }}
                >
                  <Box sx={{
                    flexShrink: 0,
                    width: 56,
                    height: 56,
                    borderRadius: 2,
                    bgcolor: `${item.color}1A`,
                    color: item.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    {item.icon}
                  </Box>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5, color: colors.textPrimary }}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: colors.textSecondary, lineHeight: 1.7 }}>
                      {item.description}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
  );
}

export default memo(ForArtists);
